import axios from 'axios';
import config from '../../config';

export const ON_HIDE_ALERT = 'ON_HIDE_ALERT';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
const SUBMIT_PENDING = 'SUBMIT_PENDING';

const initialState = {
  showAlert: false,
  isLoginSuccess: false,
  serverStatus: '',
  previousIndividualForgetPassPath: '',
  isSubmitting: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ON_HIDE_ALERT:
      return {
        ...state,
        showAlert: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoginSuccess: true,
        isSubmitting: false,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        ...action.data,
        isLoginSuccess: false,
        isSubmitting: false,
      };
    case SUBMIT_PENDING:
      return {
        ...state,
        isSubmitting: true,
      };
    default:
      return state;
  }
}

export const changeLanguage = (lang) => {
  return async (dispatch) => {
    dispatch({
      type: 'LANGUAGE_CHANGE',
      language: lang,
    });
  };
};

export const checkLoginStatus = () => {
  return async (dispatch) => {
    dispatch({
      type: SUBMIT_PENDING,
    });
    await axios.get(`${config.apiLoginStatus}`, {
      withCredentials: true,
    }).then((response) => {
      if (response.data.attempt > 0) {
        dispatch({
          type: LOGIN_FAIL,
          data: {
            attempt: response.data.attempt,
          },
        });
      } else {
        dispatch({
          type: LOGIN_FAIL,
          data: {
            attempt: 0,
          },
        });
      }
    // eslint-disable-next-line no-unused-vars
    }).catch((error) => {
      dispatch({
        type: LOGIN_FAIL,
        data: {
          attempt: 0,
        },
      });
    });
  };
};

export const modalClose = () => {
  return (dispatch) => {
    dispatch({
      type: ON_HIDE_ALERT,
    });
  };
};
